import { useRef } from 'react';

import { DefaultTrackPromotionEvent } from '@/common/analytics/gtm/shared/trackViewPromotion';
import EventTile, { EventTileProps } from '@/common/components/EventTile/EventTile';
import { UseSlideImpression } from '@/common/impressions/useSliderImpression';

interface Props extends EventTileProps {
  useSlideImpression: UseSlideImpression<DefaultTrackPromotionEvent>;
  metadata: DefaultTrackPromotionEvent;
}

const EventTileWithImpression = ({ useSlideImpression, metadata, ...props }: Props) => {
  const ref = useRef(null);

  useSlideImpression(ref, metadata);

  return <EventTile ref={ref} {...props} />;
};

export default EventTileWithImpression;
